import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.transaction');
import { normalizePhone, normalizeWebsite } from "src/libs/portal/season/contact-policy";
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { Subscription } from 'rxjs';
import { getDemoAccount } from '../admin-prototype/account';
import { buyerInquiries, currency, ipListings, ipSaleApplications, qnas } from '../admin-prototype/mock-data';
import { ipSaleApplication } from '../admin-prototype/types';

@Component({
    selector: 'wiz-page-transaction',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.transaction/view.scss */
:host {
  display: block;
  height: 100%;
}

:host .ipt-section-header__primary.ipt-content-create-button {
  display: inline-flex;
  min-width: 11.25rem;
  min-height: 4.25rem;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;
  padding: 0.6rem 1rem 0.6rem 0.65rem;
  border-color: rgba(255, 255, 255, 0.82);
  border-radius: 0.9rem;
  background: rgba(248, 254, 255, 0.96);
  text-align: left;
  box-shadow: 0 12px 26px rgba(4, 44, 54, 0.2);
  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

:host .ipt-section-header__primary.ipt-content-create-button:hover:not(:disabled) {
  border-color: #fff;
  background: #fff;
  box-shadow: 0 16px 30px rgba(4, 44, 54, 0.25);
  transform: translateY(-2px);
}

:host .ipt-section-header__primary.ipt-content-create-button:focus-visible {
  outline: 3px solid rgba(131, 227, 228, 0.55);
  outline-offset: 3px;
}

.ipt-content-create-button__icon {
  display: inline-grid;
  flex: 0 0 auto;
  width: 2.65rem;
  height: 2.65rem;
  place-items: center;
  border-radius: 0.72rem;
  color: #fff;
  background: #08798a;
  font-size: 0.88rem;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.16);
}

.ipt-content-create-button__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.2rem;
}

.ipt-content-create-button__copy strong {
  color: #07586a;
  font-size: 0.82rem;
  font-weight: 850;
  line-height: 1.15;
  letter-spacing: -0.02em;
}

.ipt-content-create-button__copy small {
  color: #64828a;
  font-size: 0.65rem;
  font-weight: 700;
  line-height: 1.2;
}

@media (max-width: 47.99rem) {
  :host .ipt-section-header__primary.ipt-content-create-button {
    width: 100%;
    min-width: 0;
  }
}
.ipt-content-list {
  overflow: hidden;
}

.ipt-content-toolbar {
  padding: 20px 22px 18px;
  border-bottom: 1px solid #dbe6e8;
  background: #fff;
}

.ipt-content-toolbar__topline {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.ipt-content-toolbar__topline h2 {
  margin: 0;
  color: #17242c;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: -0.025em;
}

.ipt-content-toolbar__topline p {
  margin: 3px 0 0;
  color: #7b8e97;
  font-size: 12px;
}

.ipt-content-controls {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) 160px 160px;
  gap: 10px;
  align-items: center;
}

.ipt-content-search, .ipt-content-select {
  min-width: 0;
}

.ipt-content-search input, .ipt-content-select select {
  width: 100%;
  height: 42px;
  border: 1px solid #cfdbdf;
  border-radius: 9px;
  background: #fff;
  color: #263d47;
  font: inherit;
  font-size: 13px;
  outline: none;
  transition: border-color 140ms ease, box-shadow 140ms ease, background 140ms ease;
}

.ipt-content-search input {
  padding: 0 14px;
}

.ipt-content-search input::placeholder {
  color: #94a5ad;
}

.ipt-content-select select {
  padding: 0 34px 0 12px;
  cursor: pointer;
}

.ipt-content-search input:hover, .ipt-content-select select:hover {
  border-color: #9fb6bd;
}

.ipt-content-search input:focus, .ipt-content-select select:focus {
  border-color: #188b99;
  box-shadow: 0 0 0 3px rgba(24, 139, 153, 0.12);
}

.ipt-content-reset {
  flex: 0 0 auto;
  border: 0;
  color: #08798a;
  background: transparent;
  font-size: 12px;
  font-weight: 750;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.ipt-content-reset:focus-visible {
  outline: 2px solid #31b0c0;
  outline-offset: 3px;
}

.ipt-content-table__head, .ipt-content-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 96px 116px 168px 68px;
  gap: 16px;
}

.ipt-content-table__head {
  align-items: center;
  min-height: 42px;
  padding: 0 22px;
  border-bottom: 1px solid #dbe6e8;
  color: #6f828b;
  background: #f7fafb;
  font-size: 11px;
  font-weight: 750;
}

.ipt-content-table__head span:not(:first-child) {
  text-align: center;
}

.ipt-content-row {
  position: relative;
  align-items: center;
  min-height: 116px;
  padding: 19px 22px;
  border-bottom: 1px solid #edf2f3;
  background: #fff;
  cursor: pointer;
  transition: background 140ms ease, box-shadow 140ms ease;
}

.ipt-content-row:last-of-type {
  border-bottom: 0;
}

.ipt-content-row:hover, .ipt-content-row:focus-within {
  background: #f9fcfc;
}

.ipt-content-row:focus-visible {
  z-index: 1;
  outline: 2px solid #31b0c0;
  outline-offset: -2px;
  box-shadow: inset 4px 0 0 #08798a;
}

.ipt-content-main {
  min-width: 0;
}

.ipt-content-titleline {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.ipt-content-title {
  min-width: 0;
  overflow: hidden;
  border: 0;
  padding: 0;
  color: #17242c;
  background: transparent;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
  letter-spacing: -0.015em;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ipt-content-row:hover .ipt-content-title, .ipt-content-row:focus-visible .ipt-content-title {
  color: #08798a;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 4px;
}

.ipt-content-pinned {
  flex: 0 0 auto;
  border-radius: 5px;
  padding: 3px 6px;
  color: #885c16;
  background: #fff5d8;
  font-size: 10px;
  font-weight: 750;
}

.ipt-content-summary {
  display: -webkit-box;
  overflow: hidden;
  max-width: 72ch;
  margin: 7px 0 0;
  color: #687d87;
  font-size: 13px;
  line-height: 1.65;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.ipt-content-cell {
  min-width: 0;
  color: #5d717b;
  font-size: 12px;
  line-height: 1.45;
  text-align: center;
}

.ipt-cell-label, .ipt-content-mobile-meta {
  display: none;
}

.ipt-content-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 54px;
  border: 1px solid;
  border-radius: 999px;
  padding: 5px 9px;
  font-size: 11px;
  font-weight: 750;
}

.ipt-content-cell--attachment {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 4px 7px;
}

.ipt-content-link-meta {
  color: #08798a;
  font-weight: 700;
}

.ipt-content-empty-meta {
  color: #a0afb5;
}

.ipt-content-cell--date time {
  color: #6b7f89;
  font-variant-numeric: tabular-nums;
}

.ipt-content-open {
  display: inline-flex;
  min-width: 54px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border: 1px solid #cddcdf;
  border-radius: 8px;
  color: #31525e;
  background: #fff;
  font-size: 11px;
  font-weight: 750;
  transition: border-color 140ms ease, color 140ms ease, background 140ms ease;
}

.ipt-content-row:hover .ipt-content-open, .ipt-content-row:focus-visible .ipt-content-open {
  border-color: #76bdc5;
  color: #056477;
  background: #effafb;
}

.ipt-content-empty {
  padding: 72px 24px;
  text-align: center;
}

.ipt-content-empty strong {
  display: block;
  color: #405963;
  font-size: 14px;
}

.ipt-content-empty p {
  margin: 7px 0 0;
  color: #899aa1;
  font-size: 12px;
}

@media (max-width: 980px) {
  .ipt-content-controls {
    grid-template-columns: minmax(220px, 1fr) repeat(2, minmax(132px, 0.45fr));
  }
  .ipt-content-table__head {
    display: none;
  }
  .ipt-content-row {
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 12px 18px;
    min-height: 0;
    padding: 18px 20px;
  }
  .ipt-content-main {
    grid-column: 1;
    grid-row: 1;
  }
  .ipt-content-cell--status {
    grid-column: 2;
    grid-row: 1;
    align-self: start;
  }
  .ipt-content-cell--attachment {
    grid-column: 1;
    grid-row: 2;
    justify-content: flex-start;
    text-align: left;
  }
  .ipt-content-cell--date {
    display: none;
  }
  .ipt-content-cell--action {
    grid-column: 2;
    grid-row: 2;
  }
  .ipt-cell-label {
    display: inline;
    color: #98a7ad;
    font-size: 10px;
    font-weight: 700;
  }
  .ipt-content-mobile-meta {
    display: flex;
    align-items: center;
    gap: 7px;
    margin-top: 9px;
    color: #82949c;
    font-size: 11px;
  }
}
@media (max-width: 640px) {
  .ipt-content-toolbar {
    padding: 17px 16px 16px;
  }
  .ipt-content-controls {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .ipt-content-search {
    grid-column: 1/-1;
  }
  .ipt-content-row {
    grid-template-columns: minmax(0, 1fr);
    padding: 17px 16px;
  }
  .ipt-content-main, .ipt-content-cell--status, .ipt-content-cell--attachment, .ipt-content-cell--action {
    grid-column: 1;
    grid-row: auto;
  }
  .ipt-content-titleline {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
  }
  .ipt-content-title {
    width: 100%;
    white-space: normal;
  }
  .ipt-content-cell--status, .ipt-content-cell--attachment, .ipt-content-cell--action {
    justify-self: start;
    text-align: left;
  }
}
.content-mini-nav {
  margin: 16px 0;
  padding: 14px;
  border: 1px solid #d5e2e5;
  border-radius: 12px;
  background: #f8fbfb;
  box-shadow: 0 5px 18px rgba(20, 57, 65, 0.05);
}

.content-mini-nav__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 10px;
}

.content-mini-nav__header p {
  margin: 0;
  color: #627780;
  font-size: 11px;
  font-weight: 700;
}

.content-mini-nav__header strong {
  display: block;
  margin-top: 2px;
  color: #18313a;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}

.content-mini-nav__paging {
  display: flex;
  align-items: center;
  gap: 6px;
}

.content-mini-nav__paging button {
  min-height: 32px;
  padding: 6px 10px;
  border: 1px solid #cfdddf;
  border-radius: 7px;
  color: #34535e;
  background: #fff;
  font-size: 11px;
  font-weight: 750;
}

.content-mini-nav__paging button:hover:not(:disabled) {
  border-color: #7ebdc4;
  color: #056477;
  background: #effafb;
}

.content-mini-nav__paging button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.content-mini-nav__list {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 1px 1px 5px;
  scrollbar-width: thin;
  scrollbar-color: #b9cacc transparent;
}

.content-mini-nav__item {
  display: flex;
  flex: 1 0 220px;
  min-width: 0;
  align-items: center;
  gap: 9px;
  min-height: 58px;
  padding: 10px 11px;
  border: 1px solid #dbe5e7;
  border-radius: 9px;
  color: #425b65;
  background: #fff;
  text-align: left;
  transition: border-color 140ms ease, color 140ms ease, background 140ms ease, box-shadow 140ms ease;
}

.content-mini-nav__item:hover {
  border-color: #83c2c9;
  color: #075b6a;
  background: #f1fafb;
}

.content-mini-nav__item.is-active {
  border-color: #08798a;
  color: #fff;
  background: #08798a;
  box-shadow: 0 4px 12px rgba(8, 121, 138, 0.16);
}

.content-mini-nav__index {
  display: inline-flex;
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  color: #08798a;
  background: #e8f7f8;
  font-size: 10px;
  font-weight: 800;
}

.content-mini-nav__item.is-active .content-mini-nav__index {
  color: #075b6a;
  background: #d7f3f4;
}

.content-mini-nav__copy {
  min-width: 0;
}

.content-mini-nav__copy strong {
  display: block;
  overflow: hidden;
  font-size: 12px;
  font-weight: 750;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-mini-nav__copy small {
  display: block;
  overflow: hidden;
  margin-top: 4px;
  color: #84969d;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-mini-nav__item.is-active .content-mini-nav__copy small {
  color: rgba(255, 255, 255, 0.72);
}

.content-mini-nav :is(button):focus-visible {
  outline: 2px solid #31b0c0;
  outline-offset: 2px;
}

@media (max-width: 640px) {
  .content-mini-nav {
    margin: 12px 0;
    padding: 12px;
  }
  .content-mini-nav__header {
    align-items: flex-end;
  }
  .content-mini-nav__paging button {
    padding-inline: 9px;
  }
  .content-mini-nav__item {
    flex-basis: 196px;
  }
}
.news-detail {
  padding: 4px 0 28px;
  color: #21343d;
}

.news-actions, .news-actions-right {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.news-actions {
  margin-bottom: 20px;
}

.news-actions button {
  border-radius: 8px;
  padding: 10px 18px;
  font-size: 12px;
  font-weight: 700;
}

.news-actions button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.news-back, .news-secondary {
  border: 1px solid #d3e1e5;
  background: white;
  color: #415b66;
}

.news-primary {
  border: 1px solid #08798a;
  background: #08798a;
  color: white;
}

.news-danger {
  border: 1px solid #e4bcbc;
  background: white;
  color: #ac3535;
}

.news-danger:hover:not(:disabled) {
  border-color: #c86262;
  background: #fff5f5;
}

.news-status, .news-pin {
  font-size: 11px;
  color: #08798a;
  background: #eaf8fa;
  padding: 5px 9px;
  border-radius: 5px;
}

.news-pin {
  color: #93620c;
  background: #fffae8;
}

.news-profile {
  display: grid;
  grid-template-columns: minmax(0, 1.65fr) minmax(0, 1fr);
  border: 1px solid #d5e0e4;
  border-radius: 12px;
  background: white;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(24, 63, 72, 0.062745098);
}

.news-profile-main {
  min-width: 0;
  padding-bottom: 20px;
}

.news-profile-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  min-height: 126px;
  border-bottom: 1px solid #e1e9ec;
  padding: 26px;
}

.news-profile-heading > div {
  min-width: 0;
}

.news-eyebrow {
  font-size: 10px;
  letter-spacing: 0.15em;
  font-weight: 800;
  color: #08798a;
  margin-bottom: 8px;
}

.news-profile-heading h1 {
  font-size: 23px;
  font-weight: 750;
  line-height: 1.4;
  letter-spacing: -0.03em;
}

.news-tagline {
  font-size: 13px;
  color: #627b86;
  margin-top: 6px;
}

.news-website {
  max-width: 100%;
  font-size: 12px;
  overflow-wrap: anywhere;
}

.news-website a {
  color: #08798a;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.news-info-row {
  display: grid;
  grid-template-columns: 128px minmax(0, 1fr);
  gap: 16px;
  padding: 0 24px;
  margin-top: 16px;
}

.news-info-row h2 {
  display: flex;
  align-items: center;
  margin: 0;
  background: #f1f5f6;
  padding: 18px 14px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.7;
}

.news-info-content {
  background: #f7f9fa;
  padding: 18px;
  min-width: 0;
}

.news-prose {
  font-size: 13px;
  white-space: pre-wrap;
  line-height: 1.9;
  overflow-wrap: anywhere;
  margin: 0;
}

.news-company-facts {
  display: grid;
  grid-template-columns: 60px minmax(0, 1fr);
  gap: 9px 12px;
  margin: 0;
  font-size: 13px;
  line-height: 1.7;
}

.news-company-facts dt {
  color: #71818a;
}

.news-company-facts dd {
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.news-profile-media {
  min-width: 0;
  border-left: 1px solid #d5e0e4;
  display: flex;
  flex-direction: column;
}

.news-profile-media h2 {
  font-size: 13px;
  font-weight: 700;
  margin: 0 0 18px;
}

.news-certificates {
  padding: 24px;
  border-bottom: 1px solid #d5e0e4;
  min-height: 255px;
}

.news-image-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.news-image-grid figure {
  min-width: 0;
  margin: 0;
}

.news-image-grid figure > button {
  width: 100%;
  border: 1px solid #e1e8eb;
  background: #f9fbfc;
  padding: 5px;
  border-radius: 5px;
}

.news-image-grid img {
  width: 100%;
  height: 180px;
  object-fit: contain;
}

.news-image-grid figcaption {
  font-size: 10px;
  color: #7b8e97;
  margin-top: 8px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.news-attachments {
  padding: 24px;
  flex: 1;
}

.news-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid #e2e9ec;
  background: #f8fafb;
  padding: 12px;
  margin: 9px 0;
  border-radius: 6px;
  font-size: 12px;
}

.news-file > button:first-child {
  text-align: left;
  min-width: 0;
  overflow-wrap: anywhere;
  color: #375965;
}

.news-file small {
  display: block;
  color: #83969e;
  font-size: 10px;
  margin-top: 4px;
}

.news-empty {
  color: #86959b;
  font-size: 11px;
  line-height: 1.8;
}

.news-delete {
  color: #b34343;
  font-size: 11px;
  flex-shrink: 0;
}

.news-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 11px;
  color: #687c87;
}

.news-field + .news-field {
  margin-top: 12px;
}

.news-detail input:not([type=checkbox]):not([type=file]), .news-detail textarea, .news-detail select {
  width: 100%;
  min-width: 0;
  border: 1px solid #cddce2;
  border-radius: 6px;
  background: white;
  color: #223b47;
  font: inherit;
  font-size: 13px;
  padding: 10px 12px;
}

.news-detail textarea {
  resize: vertical;
  line-height: 1.8;
}

.news-detail input[type=file] {
  max-width: 100%;
  font-size: 11px;
}

.news-detail :is(input, button, a, textarea, select):focus-visible {
  outline: 2px solid #31b0c0;
  outline-offset: 3px;
}

.news-detail :is(input, textarea, select):disabled {
  opacity: 0.65;
}

.news-company-edit {
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(0, 1fr);
}

.news-company-edit .news-field {
  margin: 0;
}

.news-upload {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px dashed #cddce2;
}

.news-publishing {
  grid-column: 1/-1;
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  align-items: center;
  border-top: 1px solid #d5e0e4;
  padding: 22px 24px;
  background: #f8fafb;
}

.news-publishing .news-field {
  margin: 0;
  flex: 1;
  min-width: 180px;
}

.news-pin-option {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #546971;
}

.news-publishing p {
  flex-basis: 100%;
}

.news-notice {
  padding: 12px 16px;
  background: #eaf8f3;
  color: #287254;
  font-size: 12px;
  border-radius: 8px;
  margin-bottom: 14px;
}

@media (max-width: 1100px) {
  .news-profile {
    grid-template-columns: minmax(0, 1fr);
  }
  .news-profile-media {
    border-left: 0;
    border-top: 1px solid #d5e0e4;
  }
  .news-image-grid img {
    height: 220px;
  }
}
@media (max-width: 600px) {
  .news-actions {
    align-items: flex-start;
    gap: 8px;
  }
  .news-actions-right {
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 5px;
  }
  .news-actions button {
    padding: 9px 11px;
    white-space: nowrap;
  }
  .news-profile-heading {
    padding: 20px;
  }
  .news-profile-heading h1 {
    font-size: 21px;
  }
  .news-info-row {
    grid-template-columns: minmax(0, 1fr);
    gap: 0;
    padding: 0 14px;
  }
  .news-info-row h2 {
    padding: 12px 14px;
  }
  .news-info-content {
    padding: 15px;
  }
  .news-certificates, .news-attachments {
    padding: 20px 16px;
  }
  .news-image-grid {
    gap: 7px;
  }
  .news-image-grid img {
    height: 130px;
  }
}
.content-detail {
  min-width: 0;
  padding-bottom: 28px;
  color: #21343d;
}

.content-actions {
  position: sticky;
  top: 0;
  z-index: 3;
  padding: 12px 0;
  background: #f1f7f8;
}

.content-article, .content-edit-form {
  border: 1px solid #d5e0e4;
  border-radius: 12px;
  background: white;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(24, 63, 72, 0.062745098);
}

.content-article-heading {
  padding: 28px 32px;
  border-bottom: 1px solid #e1e9ec;
}

.content-article-heading h1 {
  font-size: 24px;
  line-height: 1.5;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.content-date {
  margin-top: 12px;
  color: #7b8e97;
  font-size: 12px;
}

.content-body {
  padding: 32px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 15px;
  line-height: 2;
}

.content-resources {
  border-top: 1px solid #e1e9ec;
  padding: 24px 32px;
}

.content-resources h2 {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 12px;
}

.content-link {
  font-size: 14px;
  color: #08798a;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.content-file-image {
  display: block;
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
  margin-bottom: 12px;
}

.content-edit-form {
  padding: 28px 32px;
}

.content-edit-form textarea {
  min-height: 45vh;
}

.content-detail :is(input, button, textarea, select):focus-visible {
  outline: 2px solid #31b0c0;
  outline-offset: 3px;
}

@media (max-width: 600px) {
  .content-article-heading, .content-body, .content-resources, .content-edit-form {
    padding: 20px 16px;
  }
  .content-article-heading h1 {
    font-size: 20px;
  }
  .content-body {
    font-size: 14px;
    line-height: 1.9;
  }
}
/* Transaction dashboard insight banner */
:host .ipt-dashboard-hero.ipt-insight-hero {
  display: block !important;
  min-height: 17rem !important;
  padding: 1.65rem 1.85rem 1rem !important;
  isolation: isolate;
}

:host .ipt-insight-hero::before {
  z-index: 4;
}

:host .ipt-insight-hero::after {
  position: absolute;
  z-index: 1;
  inset: 0;
  background: linear-gradient(90deg, rgba(6, 38, 52, 0.98) 0%, rgba(6, 47, 61, 0.95) 42%, rgba(6, 64, 75, 0.78) 64%, rgba(5, 78, 87, 0.12) 84%, transparent 100%);
  pointer-events: none;
  content: "";
}

:host .ipt-insight-hero > .ipt-insight-hero__art {
  position: absolute;
  z-index: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 43%;
  overflow: hidden;
  pointer-events: none;
}

.ipt-insight-hero__art img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 58% 52%;
  filter: saturate(0.76) brightness(0.76) contrast(0.94);
  transform: scale(1.015);
}

:host .ipt-insight-hero > .ipt-hero-copy,
:host .ipt-insight-hero > .ipt-dashboard-kpis {
  position: relative;
  z-index: 2;
}

:host .ipt-insight-hero > .ipt-hero-copy {
  width: min(66%, 47rem);
  max-width: none;
}

:host .ipt-insight-hero .ipt-hero-kicker-row {
  margin-bottom: 0.7rem;
}

:host .ipt-insight-hero .ipt-hero-kicker-row .ipt-eyebrow {
  color: #8ee8e5 !important;
}

:host .ipt-insight-hero h1 {
  max-width: 46rem;
  font-size: clamp(1.7rem, 2.3vw, 2.15rem) !important;
  line-height: 1.18 !important;
}

:host .ipt-insight-hero .ipt-hero-description {
  max-width: 42rem;
  margin-top: 0.62rem;
  font-size: 0.82rem;
}

.ipt-insight-hero__cta {
  display: inline-flex;
  min-height: 2.9rem;
  align-items: center;
  justify-content: center;
  gap: 0.78rem;
  margin-top: 1rem;
  padding: 0.7rem 1.25rem;
  border: 1px solid rgba(255, 255, 255, 0.88);
  border-radius: 0.76rem;
  color: #07576a;
  background: #f8ffff;
  box-shadow: 0 10px 22px rgba(1, 26, 34, 0.22);
  font-size: 0.76rem;
  font-weight: 800;
  line-height: 1;
  transition: transform 180ms ease, box-shadow 180ms ease, background-color 180ms ease;
}

.ipt-insight-hero__cta:hover {
  color: #064b5a;
  background: #fff;
  box-shadow: 0 14px 28px rgba(1, 26, 34, 0.28);
  transform: translateY(-2px);
}

.ipt-insight-hero__cta:focus-visible {
  outline: 3px solid rgba(141, 232, 229, 0.65);
  outline-offset: 3px;
}

.ipt-insight-hero__cta i {
  font-size: 0.72rem;
}

:host .ipt-insight-hero .ipt-dashboard-kpis {
  width: min(82%, 62rem);
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.5rem;
  margin-top: 1.05rem;
}

:host .ipt-insight-hero .ipt-dashboard-kpi {
  display: grid;
  min-height: 3.75rem;
  grid-template-columns: 2.05rem minmax(0, 1fr) auto;
  grid-template-rows: auto auto;
  align-items: center;
  gap: 0.12rem 0.55rem;
  padding: 0.58rem 0.68rem;
  border-color: rgba(201, 242, 243, 0.17);
  border-radius: 0.7rem;
  background: rgba(255, 255, 255, 0.09);
  backdrop-filter: blur(8px);
}

:host .ipt-insight-hero .ipt-dashboard-kpi__icon {
  display: grid;
  width: 2.05rem;
  height: 2.05rem;
  grid-row: 1/3;
  place-items: center;
  overflow: visible;
  border: 1px solid rgba(216, 250, 250, 0.13);
  border-radius: 0.55rem;
  color: #dfffff;
  background: rgba(210, 250, 250, 0.09);
  font-size: 0.78rem;
}

.ipt-dashboard-kpi__copy {
  min-width: 0;
}

:host .ipt-insight-hero .ipt-dashboard-kpi__copy > span {
  display: block;
  overflow: hidden;
  color: rgba(231, 251, 251, 0.84);
  font-size: 0.64rem;
  font-weight: 750;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .ipt-insight-hero .ipt-dashboard-kpi__copy > small {
  display: block;
  overflow: hidden;
  margin-top: 0.2rem;
  color: rgba(222, 246, 247, 0.52);
  font-size: 0.52rem;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .ipt-insight-hero .ipt-dashboard-kpi > strong {
  grid-row: 1/3;
  color: #fff;
  font-size: 1rem;
}

@media (max-width: 1100px) {
  :host .ipt-dashboard-hero.ipt-insight-hero {
    min-height: 18rem !important;
  }
  :host .ipt-insight-hero > .ipt-hero-copy {
    width: 72%;
  }
  :host .ipt-insight-hero > .ipt-insight-hero__art {
    width: 47%;
    opacity: 0.78;
  }
  :host .ipt-insight-hero .ipt-dashboard-kpis {
    width: 100%;
  }
  :host .ipt-insight-hero .ipt-dashboard-kpi {
    grid-template-columns: 1.8rem minmax(0, 1fr) auto;
  }
  :host .ipt-insight-hero .ipt-dashboard-kpi__icon {
    width: 1.8rem;
    height: 1.8rem;
  }
}
@media (max-width: 767px) {
  :host .ipt-dashboard-hero.ipt-insight-hero {
    min-height: auto !important;
    padding: 1.25rem !important;
  }
  :host .ipt-insight-hero::after {
    background: linear-gradient(90deg, rgba(6, 38, 52, 0.98) 0%, rgba(6, 47, 61, 0.94) 66%, rgba(6, 55, 68, 0.82) 100%);
  }
  :host .ipt-insight-hero > .ipt-insight-hero__art {
    width: 70%;
    opacity: 0.34;
  }
  :host .ipt-insight-hero > .ipt-hero-copy {
    width: 100%;
  }
  :host .ipt-insight-hero h1 {
    max-width: 21rem;
    font-size: clamp(1.45rem, 7vw, 1.9rem) !important;
  }
  :host .ipt-insight-hero .ipt-hero-description {
    max-width: 27rem;
  }
  :host .ipt-insight-hero .ipt-dashboard-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-top: 1.2rem;
  }
  :host .ipt-insight-hero .ipt-dashboard-kpi {
    min-height: 3.45rem;
    grid-template-columns: 1.8rem minmax(0, 1fr) auto;
  }
}
@media (max-width: 430px) {
  :host .ipt-insight-hero .ipt-dashboard-kpi {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  :host .ipt-insight-hero .ipt-dashboard-kpi__icon {
    display: none;
  }
  :host .ipt-insight-hero .ipt-dashboard-kpi__copy > small {
    display: none;
  }
}`],
})
export class PageTransactionComponent implements OnInit, OnDestroy {
    public account = getDemoAccount();
    public section: string = 'dashboard';
    public applications: ipSaleApplication[] = ipSaleApplications;
    public rightTypes: string[] = ['특허', '실용신안', '상표', '디자인'];
    public stats: any[] = [];
    public saleActions: any[] = [];
    public purchaseActions: any[] = [];
    public rightsBreakdown: any[] = [];
    public selectedContent: any = null;
    public contentDraft: any = {};
    public pendingContentFiles: File[] = [];
    public contentSaving: boolean = false;
    public contentEditorOpen: boolean = false;
    public contentEditing = false;
    public contentNotice = '';
    public contentUploadProgress: number = 0;
    public contentLoadError: string = '';
    public contentSearch: string = '';
    public contentStatusFilter: string = '';
    public contentSort: 'latest' | 'oldest' | 'title' = 'latest';
    private routeSubscription: Subscription = null;
    private readonly maxContentFiles: number = 10;
    private readonly maxContentFileSize: number = 20 * 1024 * 1024;
    private readonly allowedContentExtensions: string[] = [
        '.pdf', '.hwp', '.hwpx', '.doc', '.docx', '.xls', '.xlsx',
        '.ppt', '.pptx', '.txt', '.csv', '.zip', '.jpg', '.jpeg', '.png'
    ];
    public contentSections: any = {
        notices: {
            label: '공지사항',
            eyebrow: 'NOTICE MANAGEMENT',
            description: '수요자용 IP 거래시스템에 노출할 공지사항을 작성하고 공개 상태를 관리합니다.',
            items: []
        },
        procedure: {
            label: '이용절차',
            eyebrow: 'PROCESS GUIDE',
            description: '판매신청부터 검수, 공개, 구매상담까지 이용자가 확인할 절차를 관리합니다.',
            items: []
        },
        business: {
            label: '사업정보',
            eyebrow: 'BUSINESS INFORMATION',
            description: 'IP 거래 지원사업의 목적, 지원범위와 운영기관 정보를 관리합니다.',
            items: []
        },
        news: {
            label: '회원소식',
            eyebrow: 'MEMBER NEWS',
            description: '회원과 참여기업의 거래 성과, 행사와 주요 소식을 등록합니다.',
            items: []
        }
    };

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.account = getDemoAccount(this.service.auth.context);

        await this.loadContent();
        this.syncSectionFromLocation();
        this.routeSubscription = this.router.events.subscribe(async (event) => {
            if (!(event instanceof NavigationEnd)) return;
            this.syncSectionFromLocation();
            await this.service.render();
            document.querySelector('.wb-route-stage')?.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
        });
        await this.service.render();
    }

    public ngOnDestroy() {
        this.routeSubscription?.unsubscribe();
    }

    private responseData(response: any) {
        const payload = response && response.responseJSON ? response.responseJSON : response;
        const status = Number(payload?.code ?? response?.status ?? 500);
        const data = payload?.data;
        if (!payload || status >= 400) {
            const message = payload?.message
                || (typeof data === 'string' ? data : data?.message)
                || response?.statusText
                || '요청을 처리하지 못했습니다.';
            throw new Error(String(message));
        }
        return data;
    }

    private cloneContent(item: any) {
        return {
            ...item,
            isPinned: item?.isPinned === true,
            linkUrl: item?.linkUrl || '',
            linkLabel: item?.linkLabel || '바로가기',
            companyProfile: { ...this.emptyProfile(), ...(item?.companyProfile || {}) },
            attachments: [...(item?.attachments || [])]
        };
    }

    private async loadContent() {
        this.contentLoadError = '';
        try {
            const data: any = this.responseData(await wiz.call('list_content', {}, { type: 'GET' }));
            ['notices', 'procedure', 'business', 'news'].forEach((key) => {
                if (Array.isArray(data?.[key])) {
                    this.contentSections[key].items = data[key];
                }
            });
        } catch (error) {
            this.contentLoadError = String(error?.message || '저장된 콘텐츠를 불러오지 못했습니다.');
        }
    }

    private syncSectionFromLocation() {
        const previousSection = this.section;
        const requestedSection = new URLSearchParams(location.search).get('section') || 'dashboard';
        if (requestedSection === 'stats') {
            this.service.href('/ip-market/statistics');
            return;
        }
        const allowedSections = ['dashboard', 'notices', 'procedure', 'business', 'news'];
        this.section = allowedSections.includes(requestedSection) ? requestedSection : 'dashboard';
        this.pendingContentFiles = [];
        this.contentUploadProgress = 0;

        if (this.isContentSection()) {
            if (previousSection !== this.section) {
                this.selectedContent = null;
                this.contentEditorOpen = false;
                this.contentSearch = '';
                this.contentStatusFilter = '';
                this.contentSort = 'latest';
            }
            this.contentDraft = this.selectedContent ? this.cloneContent(this.selectedContent) : this.emptyContent();
        } else if (previousSection !== this.section) {
            this.selectedContent = null;
            this.contentEditorOpen = false;
            this.contentDraft = {};
        }

        if (this.isContentSection()) {
            const itemId = new URLSearchParams(location.search).get('item') || '';
            this.selectedContent = this.activeContent.items.find((item: any) => item.id === itemId) || null;
            this.contentEditorOpen = !!this.selectedContent || itemId === 'new';
            this.contentEditing = itemId === 'new';
            this.contentNotice = itemId && itemId !== 'new' && !this.selectedContent ? '해당 게시글을 찾을 수 없습니다.' : '';
            this.contentDraft = this.selectedContent ? this.cloneContent(this.selectedContent) : this.emptyContent();
        }
        this.refresh();
    }

    public async navigateAction(route: string, event: MouseEvent) {
        event.preventDefault();
        await this.router.navigateByUrl(route);
    }

    public refresh() {
        const waitingApplications = this.applications.filter((item) => item.status === '검수대기');
        const supplementApplications = this.applications.filter((item) => item.status === '보완요청');
        const publicListings = ipListings.filter((item) => item.status !== '비공개');
        const waitingConsultations = qnas.filter((item) =>
            item.system === 'ip_market' &&
            item.consultationKind === '구매희망상담' &&
            item.status === '접수'
        );
        const waitingBuyerInquiries = buyerInquiries.filter((item) => item.status === '접수');
        const waitingApplicationAmount = waitingApplications.reduce((sum, item) => sum + item.desiredPrice, 0);

        this.saleActions = [
            {
                label: '판매검수',
                description: '판매자가 제출한 판매정보를 검수하거나 관리자가 신규 권리를 입력합니다.',
                count: '대기 ' + waitingApplications.length + '건',
                route: '/ip-market/applications?tab=review',
                steps: [
                    '검수대기: 판매자가 직접 입력한 신규·수정·삭제 내용 검수 및 승인',
                    '판매입력: 신규 업로드 요청 건을 관리자가 직접 입력 및 승인'
                ]
            },
            {
                label: '공개매물',
                description: '최종 검수를 마치고 수요자용 시스템에 등재된 판매 권리를 관리합니다.',
                count: publicListings.length + '건',
                route: '/ip-market/listings?view=public',
                steps: []
            }
        ];

        this.purchaseActions = [
            {
                label: '구매상담',
                description: '수요자가 공개매물에서 특정 권리를 선택해 요청한 구매상담입니다.',
                count: '접수 ' + waitingBuyerInquiries.length + '건',
                route: '/ip-market/buyer-inquiries',
                steps: []
            },
            {
                label: '상담대기',
                description: '구매 희망으로 접수된 자유상담과 AI 검색 요청을 확인하고 답변합니다.',
                count: '접수 ' + waitingConsultations.length + '건',
                route: '/ip-market/qna',
                steps: [
                    '자유상담을 통해 접수된 구매요청',
                    'AI 검색 후 접수된 구매요청'
                ]
            }
        ];

        this.stats = [
            { label: '검수대기', value: waitingApplications.length + '건', detail: currency(waitingApplicationAmount) + ' 규모' },
            { label: '보완요청', value: supplementApplications.length + '건', detail: '판매자 자료 보완 진행' },
            { label: '공개매물', value: publicListings.length + '건', detail: '수요자용 시스템 노출 기준' },
            { label: '구매상담', value: buyerInquiries.length + '건', detail: '특정 권리 선택 상담 포함' }
        ];

        this.rightsBreakdown = this.rightTypes.map((rightType) => ({
            label: rightType,
            applications: this.applications.filter((item) => item.rightType === rightType).length,
            listings: publicListings.filter((item) => item.rightType === rightType).length
        }));
    }

    public isContentSection() {
        return ['notices', 'procedure', 'business', 'news'].includes(this.section);
    }

    public get activeContent() {
        return this.contentSections[this.section];
    }

    public get contentNavigationItems() {
        return this.activeContent?.items || [];
    }

    public get selectedContentIndex() {
        if (!this.selectedContent) return -1;
        return this.contentNavigationItems.findIndex((item: any) => item.id === this.selectedContent.id);
    }

    public get currentContentPosition() {
        return this.selectedContentIndex >= 0 ? this.selectedContentIndex + 1 : 0;
    }

    public get hasPreviousContent() {
        return this.selectedContentIndex > 0;
    }

    public get hasNextContent() {
        return this.selectedContentIndex >= 0 && this.selectedContentIndex < this.contentNavigationItems.length - 1;
    }

    public get hasContentFilters() {
        return !!this.contentSearch.trim() || !!this.contentStatusFilter || this.contentSort !== 'latest';
    }

    public get filteredContentItems() {
        const query = this.contentSearch.trim().toLowerCase();
        const items = (this.activeContent?.items || []).filter((item: any) => {
            const profile = item.companyProfile || {};
            const searchable = [
                item.title,
                item.summary,
                profile.name,
                profile.tagline,
                profile.introduction
            ].filter(Boolean).join(' ').toLowerCase();
            const matchesQuery = !query || searchable.includes(query);
            const matchesStatus = !this.contentStatusFilter || item.status === this.contentStatusFilter;
            return matchesQuery && matchesStatus;
        });

        return items.slice().sort((a: any, b: any) => {
            if (this.contentSort === 'title') {
                return String(a.title || '').localeCompare(String(b.title || ''), 'ko');
            }
            const compared = String(a.updatedAt || '').localeCompare(String(b.updatedAt || ''));
            return this.contentSort === 'oldest' ? compared : -compared;
        });
    }

    public contentSummary(item: any) {
        const profile = item?.companyProfile || {};
        return item?.summary || profile.tagline || profile.introduction || '등록된 요약이 없습니다.';
    }

    public async applyContentFilters() {
        await this.service.render();
    }

    public async clearContentFilters() {
        this.contentSearch = '';
        this.contentStatusFilter = '';
        this.contentSort = 'latest';
        await this.service.render();
    }

    public emptyContent() {
        return {
            id: '',
            title: '',
            summary: '',
            status: '임시저장',
            isPinned: false,
            updatedAt: '',
            linkUrl: '',
            linkLabel: '바로가기',
            companyProfile: this.emptyProfile(),
            attachments: []
        };
    }

    public async selectContent(item: any) {
        if (this.contentSaving) return;
        await this.router.navigate(['/transaction'], { queryParams: { section: this.section, item: item.id } });
    }

    public async selectAdjacentContent(offset: number) {
        const target = this.contentNavigationItems[this.selectedContentIndex + offset];
        if (!target) return;
        await this.selectContent(target);
    }

    public async activateContentRow(item: any, event: KeyboardEvent) {
        event.preventDefault();
        await this.selectContent(item);
    }

    public async newContent() {
        if (this.contentSaving) return;
        await this.router.navigate(['/transaction'], { queryParams: { section: this.section, item: 'new' } });
    }

    public async closeContentEditor() {
        if (this.contentSaving) return;
        await this.router.navigate(['/transaction'], { queryParams: { section: this.section } });
    }

    public emptyProfile() {
        return { name: '', tagline: '', region: '', industry: '', representative: '', address: '', phone: '', introduction: '', achievements: '', recentNews: '' };
    }

    public async editContent() {
        this.contentDraft = this.cloneContent(this.selectedContent);
        this.contentEditing = true;
        this.contentNotice = '';
        await this.service.render();
    }

    public async cancelContentEdit() {
        if (this.contentSaving) return;
        if (!this.selectedContent) return this.closeContentEditor();
        this.contentDraft = this.cloneContent(this.selectedContent);
        this.pendingContentFiles = [];
        this.contentEditing = false;
        this.contentNotice = '';
        await this.service.render();
    }

    public get newsImages() {
        return (this.contentDraft.attachments || []).filter((file: any) => this.contentImageUrl(file) && !file.name.includes('첨부자료 목록'));
    }

    public get newsFiles() {
        return (this.contentDraft.attachments || []).filter((file: any) => !this.contentImageUrl(file) || file.name.includes('첨부자료 목록'));
    }

    public async onContentFilesSelected(event: any) {
        const selected = Array.from(event?.target?.files || []) as File[];
        const accepted: File[] = [];
        const rejected: string[] = [];
        let currentCount = (this.contentDraft.attachments || []).length + this.pendingContentFiles.length;

        for (const file of selected) {
            const dot = file.name.lastIndexOf('.');
            const extension = dot >= 0 ? file.name.slice(dot).toLowerCase() : '';
            if (!this.allowedContentExtensions.includes(extension)) {
                rejected.push(file.name + ': 지원하지 않는 파일 형식');
                continue;
            }
            if (file.size > this.maxContentFileSize) {
                rejected.push(file.name + ': 20MB 초과');
                continue;
            }
            if (currentCount >= this.maxContentFiles) {
                rejected.push(file.name + ': 최대 10개 초과');
                continue;
            }
            accepted.push(file);
            currentCount += 1;
        }

        this.pendingContentFiles = [...this.pendingContentFiles, ...accepted];
        if (event?.target) event.target.value = '';
        if (rejected.length) {
            await this.service.modal.error(rejected.join('\n'));
        }
        await this.service.render();
    }

    public async removePendingContentFile(index: number) {
        this.pendingContentFiles.splice(index, 1);
        await this.service.render();
    }

    private upsertContent(item: any) {
        const rows = this.activeContent.items;
        const index = rows.findIndex((row: any) => row.id === item.id);
        if (index >= 0) rows[index] = item;
        else rows.unshift(item);
        rows.sort((a: any, b: any) =>
            Number(b.isPinned === true) - Number(a.isPinned === true)
            || String(b.updatedAt || '').localeCompare(String(a.updatedAt || ''))
            || String(b.id || '').localeCompare(String(a.id || ''))
        );
    }

    public async saveContent() {
        if (this.contentSaving || this.contentLoadError) return;
        if (this.section === 'news' && !String(this.contentDraft.title || '').trim()) {
            this.contentDraft.title = this.contentDraft.companyProfile.name;
        }
        if (!String(this.contentDraft.title || '').trim() || (this.section !== 'news' && !String(this.contentDraft.summary || '').trim())) {
            await this.service.modal.error('제목과 내용을 입력해주세요.');
            return;
        }

        if (this.section === 'news') {
            const phone = normalizePhone(this.contentDraft.companyProfile.phone || '');
            if (phone === null) {
                await this.service.modal.error('연락처 형식을 확인해 주세요. 예: 010-0000-0000 또는 02-0000-0000'); return;
            }
            this.contentDraft.companyProfile.phone = phone;
        }
        const website = normalizeWebsite(this.contentDraft.linkUrl || '');
        if (website === null) {
            await this.service.modal.error('홈페이지는 올바른 http 또는 https 주소로 입력해 주세요.'); return;
        }
        this.contentDraft.linkUrl = website;

        this.contentSaving = true;
        this.contentUploadProgress = 0;
        await this.service.render();

        try {
            const payload = {
                id: this.contentDraft.id || '',
                title: this.contentDraft.title,
                summary: this.contentDraft.summary,
                status: this.contentDraft.status,
                isPinned: this.contentDraft.isPinned === true,
                linkUrl: this.contentDraft.linkUrl || '',
                linkLabel: this.contentDraft.linkLabel || '바로가기',
                ...(this.section === 'news' ? { companyProfile: this.contentDraft.companyProfile } : {})
            };
            let saved: any = this.responseData(await wiz.call('save_content', {
                section: this.section,
                data: JSON.stringify(payload)
            }));
            this.upsertContent(saved);

            const files = [...this.pendingContentFiles];
            for (let index = 0; index < files.length; index += 1) {
                const form = new FormData();
                form.append('section', this.section);
                form.append('content_id', saved.id);
                form.append('file', files[index]);
                const response: any = await this.service.file.upload(
                    wiz.url('upload_content_file'),
                    form,
                    async (percent: number) => {
                        this.contentUploadProgress = Math.round(((index + percent / 100) / files.length) * 100);
                        await this.service.render();
                    }
                );
                saved = this.responseData(response);
                this.upsertContent(saved);
                this.pendingContentFiles = files.slice(index + 1);
            }

            this.selectedContent = this.activeContent.items.find((item: any) => item.id === saved.id) || saved;
            this.contentDraft = this.cloneContent(this.selectedContent);
            this.pendingContentFiles = [];
            this.contentUploadProgress = files.length ? 100 : 0;
            this.contentEditing = false;
            if (new URLSearchParams(location.search).get('item') !== saved.id) {
                await this.router.navigate(['/transaction'], { queryParams: { section: this.section, item: saved.id }, replaceUrl: true });
            }
            this.contentNotice = this.activeContent.label + '이 저장되었습니다.';
        } catch (error) {
            await this.service.modal.error(String(error?.message || '콘텐츠를 저장하지 못했습니다.'));
        } finally {
            this.contentSaving = false;
            await this.service.render();
        }
    }

    public async deleteContent() {
        if (!this.selectedContent?.id || this.contentSaving || this.contentEditing || !this.isContentSection()) return;
        const sectionLabel = String(this.activeContent?.label || '콘텐츠');
        const title = String(this.selectedContent.title || '선택한 항목');
        const confirmed = await this.service.modal.show({
            title: sectionLabel + ' 삭제',
            message: '“' + title + '” 항목을 삭제하시겠습니까?\n삭제한 내용과 첨부파일은 복구할 수 없습니다.',
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;

        this.contentSaving = true;
        await this.service.render();
        try {
            const deleted: any = this.responseData(await wiz.call('delete_content', {
                section: this.section,
                content_id: this.selectedContent.id
            }));
            const index = this.activeContent.items.findIndex((item: any) => item.id === deleted.id);
            if (index >= 0) this.activeContent.items.splice(index, 1);
            this.selectedContent = null;
            this.contentDraft = this.emptyContent();
            this.pendingContentFiles = [];
            this.contentEditing = false;
            this.contentEditorOpen = false;
            await this.router.navigate(['/transaction'], {
                queryParams: { section: this.section },
                replaceUrl: true
            });
            this.contentNotice = sectionLabel + ' 항목이 삭제되었습니다.';
        } catch (error) {
            await this.service.modal.error(String(error?.message || sectionLabel + ' 항목을 삭제하지 못했습니다.'));
        } finally {
            this.contentSaving = false;
            await this.service.render();
        }
    }

    public async deleteContentFile(attachment: any) {
        if (!this.contentDraft.id || this.contentSaving) return;
        const confirmed = await this.service.modal.show({
            title: '자료 삭제',
            message: attachment.name + ' 파일을 삭제하시겠습니까?',
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;

        try {
            const saved: any = this.responseData(await wiz.call('delete_content_file', {
                section: this.section,
                content_id: this.contentDraft.id,
                attachment_id: attachment.id
            }));
            this.upsertContent(saved);
            this.selectedContent = this.activeContent.items.find((item: any) => item.id === saved.id) || saved;
            this.contentDraft = this.cloneContent(this.selectedContent);
        } catch (error) {
            await this.service.modal.error(String(error?.message || '자료를 삭제하지 못했습니다.'));
        }
        await this.service.render();
    }

    public contentImageUrl(attachment: any) {
        if (!this.contentDraft.id || !attachment?.id || !/\.(jpg|jpeg|png)$/i.test(attachment.name || '')) return '';
        const query = new URLSearchParams({
            section: this.section,
            content_id: this.contentDraft.id,
            attachment_id: attachment.id
        });
        return wiz.url('download_content_file') + '?' + query.toString();
    }

    public downloadContentFile(attachment: any) {
        if (!this.contentDraft.id || !attachment?.id) return;
        const query = new URLSearchParams({
            section: this.section,
            content_id: this.contentDraft.id,
            attachment_id: attachment.id
        });
        window.open(wiz.url('download_content_file') + '?' + query.toString(), '_blank', 'noopener,noreferrer');
    }

    public openContentLink(url: string) {
        let normalized = String(url || '').trim();
        if (!normalized) return;
        if (!/^https?:\/\//i.test(normalized)) normalized = 'https://' + normalized;
        window.open(normalized, '_blank', 'noopener,noreferrer');
    }

    public formatFileSize(size: number) {
        const bytes = Number(size || 0);
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    public contentStatusClass(status: string) {
        return status === '공개'
            ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
            : 'border-gray-200 bg-gray-50 text-gray-600';
    }
}

export default PageTransactionComponent;